import { onMounted, ref, getCurrentInstance } from 'vue'

export default function () {
  const levelTypeEnums = ref([])

  const { proxy } = getCurrentInstance()

  async function getLevelTypes() {
    const res = await proxy.$http({
      type: 'get',
      url: '/Level/getLevelLists',
      params: {
        page: 1,
        limit: 1000,
      },
    })
    if (res.code == 0) {
      levelTypeEnums.value = [...res.data.data, { id: 0, title: '无配置' }]
    }
  }

  onMounted(() => {
    getLevelTypes()
  })

  function getUserLevelName(id) {
    const temp = levelTypeEnums.value.find((item) => id == item.id)
    if (temp) {
      return temp.title
    } else {
      return ''
    }
  }

  return { levelTypeEnums, getUserLevelName }
}
